(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ClosingContractReason', ClosingContractReason);

    ClosingContractReason.$inject = ['$resource'];

    function ClosingContractReason ($resource) {
        var resourceUrl =  'api/closing-contract-reasons/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
